var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sphere-table",
      class: [
        _vm.tableType,
        _vm.soloFullHeightTable ? "full-height-kendo-table" : ""
      ]
    },
    [
      _c(
        "div",
        { class: _vm.tableContainerClass },
        [
          _c("div", { staticClass: "k-table-actions" }, [
            _vm.tableHeaderDesc
              ? _c("div", { staticClass: "table-header-table-desc" }, [
                  _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.tableHeaderDesc) +
                        "\n        "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-header-actions justify-end align-center" },
              [
                _vm.tableSettings && _vm.tableSettings.customViews
                  ? _c(
                      "div",
                      { staticClass: "mr-auto" },
                      [
                        _vm.showCv
                          ? _c("custom-view-input", {
                              ref: "customViewInput",
                              attrs: {
                                columns: _vm.columnOverrides,
                                "applied-filters-count": _vm.appliedFilterCount,
                                "is-adv-filters-applied":
                                  _vm.isOrAdvFiltersApplied,
                                filter: _vm.filter,
                                sort: _vm.sort,
                                "page-size": _vm.pageSize,
                                "is-all-applied": _vm.isAllApplied,
                                skip: _vm.skip,
                                group: _vm.group,
                                loading: _vm.isLoading,
                                "module-name": _vm.moduleName,
                                "custom-views": _vm.customViews,
                                "default-view": _vm.defaultView
                              },
                              on: {
                                "custom-view-selected": _vm.selectCustomView,
                                "custom-view-added": _vm.customViewAdded
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("aboveTable", null, {
                  totalItemsCount: _vm.totalItemsCount,
                  extraResponseProperties: _vm.extraResponseProperties,
                  filteredItemsCount: _vm.filteredItemsCount
                }),
                _vm._v(" "),
                _vm._t("actionBtns"),
                _vm._v(" "),
                _vm._t("saveReportBtns", null, { props: _vm.saveReportProps }),
                _vm._v(" "),
                _vm.isReorderable || _vm.columnToggleable
                  ? _c("column-management-btn", {
                      ref: "column-management-btn",
                      attrs: {
                        columns: _vm.columnOverrides,
                        filters: _vm.filter,
                        group: _vm.group,
                        "hide-reorder-and-lock":
                          _vm.columnToggleable && _vm.tableType === "simple",
                        disabled: _vm.isDisabled || _vm.disableColumnMngt,
                        "table-key": _vm.configurableTableKey
                      },
                      on: {
                        "show-all-columns": _vm.showAllColumns,
                        "reset-default-columns": _vm.resetDefaultColumns,
                        "toggle-column": _vm.toggleColumn,
                        "move-column": _vm.moveColumn,
                        "lock-column": _vm.lockColumn
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-dialog",
                  {
                    attrs: { "max-width": "500px", persistent: "" },
                    model: {
                      value: _vm.openDialog,
                      callback: function($$v) {
                        _vm.openDialog = $$v
                      },
                      expression: "openDialog"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-card-text",
                          [
                            _c(
                              "v-layout",
                              [
                                _c("v-flex", [
                                  _vm._v(" " + _vm._s(_vm.alertMessage) + " ")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "c-pointer",
                                        on: {
                                          click: function($event) {
                                            _vm.openDialog = false
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    close\n                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("filter-control-btn", {
                  ref: "filter-control-btn",
                  attrs: {
                    disabled: _vm.isDisabled,
                    "show-advanced-filter":
                      _vm.tableType == "granular" ||
                      _vm.tableType == "simpleGranular" ||
                      _vm.advancedFilterable,
                    "is-or-applied": _vm.isOrAdvFiltersApplied,
                    "applied-filter-count": _vm.appliedFilterCount
                  },
                  on: {
                    "clear-all": _vm.clearAllSortsFiltersAndGrouping,
                    "set-show-filters": _vm.setShowFilters,
                    "open-adv-filter": _vm.openExternalFilters
                  }
                }),
                _vm._v(" "),
                !_vm.nonDownloadable
                  ? _c("download-btn", {
                      attrs: {
                        "filtered-items": _vm.filteredItems,
                        columns: _vm.columnOverrides,
                        name: _vm.name,
                        "server-side": _vm.isServerSide,
                        "api-endpoint": _vm.apiEndpoint,
                        filter: _vm.filter,
                        sort: _vm.sort,
                        disabled: _vm.isDisabled
                      },
                      on: {
                        error: function(error) {
                          return _vm.$emit("error", error)
                        }
                      }
                    })
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _vm.tableType == "granular" ||
              _vm.tableType == "simpleGranular" ||
              _vm.advancedFilterable
                ? _c("external-filter", {
                    ref: "external-filters",
                    attrs: {
                      columns: _vm.columnOverrides,
                      "grid-filter": _vm.filter,
                      "module-name": _vm.moduleName
                    },
                    on: { "external-filters": _vm.applyExternalFilters }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "skeleton-loader",
            { attrs: { loading: _vm.isLoading, type: "table" } },
            [
              _c(
                "grid",
                _vm._g(
                  _vm._b(
                    {
                      ref: "grid",
                      class: _vm.isDragging,
                      style: { cursor: _vm.dragging ? "grabbing" : "default" },
                      attrs: {
                        "data-items": _vm.paginatedItems,
                        columns: _vm.columnOverrides,
                        filterable: true,
                        resizable: true,
                        loader: _vm.isUpdating,
                        reorderable: _vm.isReorderable,
                        groupable: _vm.isGroupable,
                        group: _vm.group,
                        "expand-field": "expanded",
                        pager: "paginationSlotTemplate",
                        "selected-field": _vm.selectedField
                      },
                      on: {
                        rowclick: _vm.onSelectionChange,
                        headerselectionchange: _vm.onHeaderSelectionChange,
                        columnreorder: _vm.columnReorder,
                        columnresize: _vm.onColumnResize,
                        expandchange: _vm.onExpandchange,
                        datastatechange: _vm.onDatastatechange
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "headerTemplate",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                _c(
                                  "div",
                                  [
                                    _vm.showFilterComponents
                                      ? _c("column-title", {
                                          ref: "column-title-" + props.field,
                                          attrs: {
                                            field: props.field,
                                            title: props.title,
                                            disabled: _vm.isDisabled,
                                            columns: _vm.columnOverrides
                                          },
                                          on: {
                                            "change-sort": _vm.changeSort,
                                            "remove-sort": _vm.removeSort,
                                            "fit-column-content":
                                              _vm.fitColumnContent
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._t("below-header", null, null, {
                                      props: props
                                    })
                                  ],
                                  2
                                )
                              ]
                            }
                          },
                          {
                            key: "emptySlot",
                            fn: function() {
                              return undefined
                            },
                            proxy: true
                          },
                          {
                            key: "rowReorder",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                _c("re-order", {
                                  style: {
                                    cursor: _vm.dragging ? "grabbing" : "grab"
                                  },
                                  attrs: {
                                    "data-item": props.dataItem,
                                    field: props.field,
                                    "drop-position": _vm.dropPosition
                                  },
                                  on: {
                                    dragHandler: _vm.dragHandler,
                                    pressHandler: _vm.pressHandler,
                                    releaseHandler: _vm.releaseHandler
                                  }
                                })
                              ]
                            }
                          },
                          {
                            key: "selectTemplate",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                props.rowType == "data"
                                  ? _c(
                                      "td",
                                      [
                                        props.dataItem.selectable != false
                                          ? _c("div", [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      props.dataItem.selected,
                                                    expression:
                                                      "props.dataItem.selected"
                                                  }
                                                ],
                                                staticClass:
                                                  "k-checkbox k-checkbox-md k-rounded-md",
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    props.dataItem.selected
                                                  )
                                                    ? _vm._i(
                                                        props.dataItem.selected,
                                                        null
                                                      ) > -1
                                                    : props.dataItem.selected
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$a =
                                                          props.dataItem
                                                            .selected,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              props.dataItem,
                                                              "selected",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              props.dataItem,
                                                              "selected",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          props.dataItem,
                                                          "selected",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                    function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.onSelectionChange(
                                                        props,
                                                        true
                                                      )
                                                    }
                                                  ]
                                                }
                                              })
                                            ])
                                          : _c(
                                              "v-icon",
                                              {
                                                class:
                                                  props.dataItem
                                                    .noSelectIconColor,
                                                attrs: {
                                                  title:
                                                    props.dataItem
                                                      .noSelectMessage ||
                                                    "This item is not selectable"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      props.dataItem
                                                        .noSelectIcon ||
                                                        _vm.SbIcons.status.warn
                                                    ) +
                                                    "\n            "
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  : props.rowType == "groupHeader"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "group-select-checkbox",
                                        style:
                                          "left: " +
                                          (30 + props.level * 32) +
                                          "px"
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: props.dataItem.selected,
                                              expression:
                                                "props.dataItem.selected"
                                            }
                                          ],
                                          staticClass:
                                            "k-checkbox k-checkbox-md k-rounded-md",
                                          attrs: {
                                            id:
                                              "group-select-checkbox-level-" +
                                              props.level,
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              props.dataItem.selected
                                            )
                                              ? _vm._i(
                                                  props.dataItem.selected,
                                                  null
                                                ) > -1
                                              : props.dataItem.selected
                                          },
                                          on: {
                                            change: [
                                              function($event) {
                                                var $$a =
                                                    props.dataItem.selected,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        props.dataItem,
                                                        "selected",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        props.dataItem,
                                                        "selected",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    props.dataItem,
                                                    "selected",
                                                    $$c
                                                  )
                                                }
                                              },
                                              function($event) {
                                                $event.stopPropagation()
                                                return _vm.onSelectionChange(
                                                  props,
                                                  true,
                                                  true,
                                                  props.level
                                                )
                                              }
                                            ]
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "timeTemplate",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                _c("td", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        new Date(
                                          props.dataItem[props.field] * 1000
                                        )
                                          .toISOString()
                                          .slice(11, 19)
                                      ) +
                                      "\n          "
                                  )
                                ])
                              ]
                            }
                          },
                          {
                            key: "filterSlotTemplate",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                _vm.showFilterComponents
                                  ? _c("column-filter", {
                                      ref: "column-filter-" + props.field,
                                      attrs: {
                                        field: props.field,
                                        "filter-type": props.filterType,
                                        columns: _vm.columnOverrides,
                                        "show-filters": _vm.showFilters,
                                        disabled: _vm.isDisabled,
                                        "server-side": _vm.isServerSide,
                                        "is-utc-time": _vm.isUtcTime
                                      },
                                      on: {
                                        "add-filters": _vm.addFilters,
                                        "change-empty-filter":
                                          _vm.changeEmptyFilter,
                                        "change-filters": _vm.changeFilters,
                                        "remove-filters": _vm.removeFilters,
                                        "change-sort": _vm.changeSort,
                                        "remove-sort": _vm.removeSort,
                                        "clear-column-filters":
                                          _vm.clearColumnFilters,
                                        "set-show-filters": _vm.setShowFilters,
                                        "set-column-width": _vm.setColumnWidth
                                      }
                                    })
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "paginationSlotTemplate",
                            fn: function() {
                              return [
                                _vm.hasColumns
                                  ? _c("pagination-controls", {
                                      ref: "pagination",
                                      attrs: {
                                        skip: _vm.skip,
                                        "total-items-count":
                                          _vm.totalItemsCount,
                                        "filtered-items-count":
                                          _vm.filteredItemsCount,
                                        "has-filters": _vm.hasFilters,
                                        "is-server-side": _vm.isServerSide,
                                        disabled: _vm.disabled,
                                        "selected-items-count": [
                                          "actionable",
                                          "granular"
                                        ].includes(_vm.tableType)
                                          ? _vm.selectedItemsCount
                                          : 0
                                      },
                                      on: {
                                        "set-page": _vm.setPage,
                                        "set-page-size": _vm.setPageSize
                                      }
                                    })
                                  : _vm._e()
                              ]
                            },
                            proxy: true
                          },
                          _vm._l(_vm.$scopedSlots, function(_, slotName) {
                            return {
                              key: slotName,
                              fn: function(slotData) {
                                return [_vm._t(slotName, null, null, slotData)]
                              }
                            }
                          })
                        ],
                        null,
                        true
                      )
                    },
                    "grid",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                ),
                [
                  _c(
                    "grid-no-records",
                    [
                      _vm.hasNoItems
                        ? _vm._t("noRecordsMsg", [
                            _vm._v(
                              "\n            No records available\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.hasNoItems && _vm.$slots.noFilteredRecordsMsg
                        ? _vm._t("noFilteredRecordsMsg", [
                            _vm._v(
                              "\n            No records available\n          "
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._v(" "),
                  _vm._l(Object.keys(_vm.$slots), function(slot) {
                    return _vm._t(slot, null, { slot: slot })
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.showDropHints
                ? _c("drag-clue", {
                    attrs: {
                      top: _vm.top,
                      left: _vm.left,
                      "data-item": _vm.activeItem,
                      "show-content": _vm.showDragClueContent,
                      columns: _vm.columnOverrides
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }